// src/utils/googleAuth.ts
import { fetchWithAuth } from "../../auth/auth";
import { processLoginResponse } from "./loginAction";
import { getApiUrl } from "../../utils/getApiUrl";


export const handleGoogleLogin = async (
  credential: string | undefined,
  navigate: (path: string) => void,
  onError: (message: string) => void,
  showSpinner: () => void,
  hideSpinner: () => void
) => {
  if (!credential) {
    onError("Google authentication failed.");
    return;
  }

  showSpinner();
  try {
    const resp = await fetchWithAuth(getApiUrl("auth/google"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ credential }),
    });

    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(txt || "Google login failed");
    }

    const data = await resp.json();
    processLoginResponse({ data, navigate, onError });
  } catch (err: unknown) {
    console.error(err);
    onError("Google login failed.");
  } finally {
    hideSpinner();
  }
};